module.exports = __webpack_public_path__ + "img/C03TechGiftofBalor_ua.5f58536a.webp";